import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthRouteModule } from './oauth-route.module';
import { OauthComponent } from './oauth.component';
import { FormsModule } from '@angular/forms';
import { TermsComponent } from '@app/CustomControls/terms/terms.component';
import { UserBlockComponent } from '@app/CustomControls/user-block/user-block.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OauthRouteModule
  ],
  declarations: [OauthComponent, TermsComponent, UserBlockComponent]
})
export class OauthModule { }
